// Generated types for ConstraintUsage
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SysMLUsageReadAPI, SysMLUsageWriteAPI } from './sysmlusage';
import { SysMLUsageReadAPISchemaObject, SysMLUsageWriteAPISchemaObject } from './sysmlusage';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ConstraintUsageReadAPI extends SysMLUsageReadAPI {
}

export interface ConstraintUsageWriteAPI extends SysMLUsageWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ConstraintUsageReadAPISchema: z.ZodType<ConstraintUsageReadAPI> = SysMLUsageReadAPISchemaObject.extend({}).passthrough();

export const ConstraintUsageWriteAPISchema: z.ZodType<ConstraintUsageWriteAPI> = SysMLUsageWriteAPISchemaObject.extend({}).passthrough();
